// QuestionaireForm.jsx

import React from "react";
import { styles } from "../components/listingspage/SingleListingPageStyles"; // Adjust path if needed

const QuestionnaireForm = ({
  questionnaire,
  handleQuestionnaireChange,
  handleQuestionnaireSubmit,
  loadingSubmit,
}) => {
  const { animals, dog, cat, other } = questionnaire;

  return (
    <div style={styles ? styles.formContainer : { marginBottom: "1rem" }}>
      <h2 style={styles ? styles.formTitle : {}}>Pre-Viewing Questionnaire</h2>
      <form onSubmit={handleQuestionnaireSubmit}>
        {/* Earliest Move-in Date */}
        <label style={styles ? styles.label : {}} htmlFor="moveInDate">
          Earliest Move-in Date
        </label>
        <input
          type="date"
          name="moveInDate"
          value={questionnaire.moveInDate}
          onChange={handleQuestionnaireChange}
          style={styles ? styles.inputField : {}}
          required
        />
        <p style={{ fontSize: "0.9rem", marginTop: "0.25rem", color: "#555" }}>
          The closer your move-in date is to the date that the rental is
          available - the better. Fewer days of vacancy will increase your
          chances of getting approved.
        </p>

        {/* Number of Animals */}
        <label style={styles ? styles.label : {}} htmlFor="animals">
          Number of Animals
        </label>
        <input
          type="number"
          name="animals"
          min="0"
          placeholder="Number of Animals"
          value={questionnaire.animals}
          onChange={handleQuestionnaireChange}
          style={styles ? styles.inputField : {}}
          required
        />

        {Number(animals) > 0 && (
          <>
            {/* Animal Types Section */}
            <div style={{ marginTop: "1rem" }}>
              <p style={{ fontWeight: "bold" }}>Animal Types:</p>
              <label style={{ display: "inline-block", marginRight: "1rem" }}>
                <input
                  type="checkbox"
                  name="dog"
                  checked={!!dog}
                  onChange={(e) =>
                    handleQuestionnaireChange({
                      target: {
                        name: "dog",
                        value: dog ? "" : "yes",
                      },
                    })
                  }
                />
                Dog
              </label>
              {dog && (
                <input
                  type="number"
                  name="dogCount"
                  min="0"
                  placeholder="Number of Dogs"
                  value={questionnaire.dogCount || ""}
                  onChange={handleQuestionnaireChange}
                  style={styles ? styles.inputField : { marginLeft: "0.5rem" }}
                />
              )}

              <br />

              <label style={{ display: "inline-block", marginRight: "1rem", marginTop: "0.5rem" }}>
                <input
                  type="checkbox"
                  name="cat"
                  checked={!!cat}
                  onChange={(e) =>
                    handleQuestionnaireChange({
                      target: {
                        name: "cat",
                        value: cat ? "" : "yes",
                      },
                    })
                  }
                />
                Cat
              </label>
              {cat && (
                <input
                  type="number"
                  name="catCount"
                  min="0"
                  placeholder="Number of Cats"
                  value={questionnaire.catCount || ""}
                  onChange={handleQuestionnaireChange}
                  style={styles ? styles.inputField : { marginLeft: "0.5rem" }}
                />
              )}

              <br />

              <label style={{ display: "inline-block", marginRight: "1rem", marginTop: "0.5rem" }}>
                <input
                  type="checkbox"
                  name="other"
                  checked={!!other}
                  onChange={(e) =>
                    handleQuestionnaireChange({
                      target: {
                        name: "other",
                        value: other ? "" : "yes",
                      },
                    })
                  }
                />
                Other
              </label>
              {other && (
                <div style={{ marginLeft: "1rem", marginTop: "0.5rem" }}>
                  <input
                    type="text"
                    name="otherDescription"
                    placeholder="Describe other animals"
                    value={questionnaire.otherDescription || ""}
                    onChange={handleQuestionnaireChange}
                    style={styles ? styles.inputField : {}}
                  />
                  <input
                    type="number"
                    name="otherCount"
                    min="0"
                    placeholder="Number of Other Animals"
                    value={questionnaire.otherCount || ""}
                    onChange={handleQuestionnaireChange}
                    style={
                      styles ? { ...styles.inputField, marginLeft: "0.5rem" } : { marginLeft: "0.5rem" }
                    }
                  />
                </div>
              )}
            </div>

            {/* Number of ESA or Service Animals */}
            <label
              style={{ ...styles?.label, marginTop: "1rem" }}
              htmlFor="esaCount"
            >
              Number of ESA or Service Animals
            </label>
            <input
              type="number"
              name="esaCount"
              min="0"
              placeholder="Number of ESA/Service Animals"
              value={questionnaire.esaCount || ""}
              onChange={handleQuestionnaireChange}
              style={styles ? styles.inputField : {}}
            />
          </>
        )}

        {/* Source of Rent Payments */}
        <input
          type="text"
          name="rentSource"
          placeholder="Source of Income"
          value={questionnaire.rentSource}
          onChange={handleQuestionnaireChange}
          style={styles ? styles.inputField : { marginTop: "1rem" }}
          required
        />

        {/* Take Home Monthly Income After Taxes */}
        <input
          type="number"
          name="takeHomeIncome"
          placeholder="Take Home Monthly Income After Taxes"
          value={questionnaire.takeHomeIncome || ""}
          onChange={handleQuestionnaireChange}
          style={styles ? styles.inputField : { marginTop: "1rem" }}
          required
        />

        {/* Estimate of Recurring Monthly Expenses */}
        {/* <input
          type="number"
          name="recurringExpenses"
          placeholder="Estimate of Recurring Monthly Expenses without Rent"
          value={questionnaire.recurringExpenses || ""}
          onChange={handleQuestionnaireChange}
          style={styles ? styles.inputField : { marginTop: "1rem" }}
          required
        /> */}

        {/* Bankruptcy or Evictions Checkbox */}
        <label style={styles ? styles.label : { marginTop: "1rem" }}>
          <input
            type="checkbox"
            name="bankruptcy"
            checked={questionnaire.bankruptcy === "yes"}
            onChange={() =>
              handleQuestionnaireChange({
                target: {
                  name: "bankruptcy",
                  value: questionnaire.bankruptcy === "yes" ? "" : "yes",
                },
              })
            }
          />
          Do you, or anyone that will be applying with you, have any recent late payments, collections, bankruptcies or evictions on your credit report? If yes, please list anything that is less than five years old.        </label>

        {/* Credit History */}
        <textarea
          name="creditHistory"
          placeholder="How is your credit? Any payments 30 days late? Collections for household bills?"
          value={questionnaire.creditHistory || ""}
          onChange={handleQuestionnaireChange}
          style={styles ? styles.inputField : { marginTop: "1rem" }}
          required
        />

        <button
          type="submit"
          style={styles ? styles.submitButton : { marginTop: "1rem" }}
          disabled={loadingSubmit}
        >
          {loadingSubmit ? "Submitting..." : "Next: Schedule Viewing"}
        </button>
      </form>
    </div>
  );
};

export default QuestionnaireForm;

